module.exports = __webpack_public_path__ + "img/david_michelangelo.fea49a33.png";